import { FormattedMessage } from 'react-intl'
import Group from 'components/utils/Group'
import LineSyncIcon from 'LuxKit/Icons/line/LineSyncIcon'
import TextLink from 'LuxKit/TextLink'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  loyaltyCurrencyLabel?: string
  switchRegionPath?: string
  onSwitchRegion?: () => void
  /** Inline link only, for table-style output rows. */
  variant?: 'inline' | 'stacked'
  linkWeight?: 'regular' | 'bold'
}

function LoyaltySwitchRegionPrompt(props: Props) {
  const {
    loyaltyCurrencyLabel,
    switchRegionPath,
    onSwitchRegion,
    variant = 'stacked',
    linkWeight = 'bold',
  } = props

  const switchLink = (
    <TextLink
      size="medium"
      weight={linkWeight}
      endIcon={<LineSyncIcon size="XS" />}
      onClick={onSwitchRegion}
      href={switchRegionPath}
    >
      <FormattedMessage
        id="N_ufYqvQN3hfk5C-ia_Q"
        defaultMessage="Switch to {currency}"
        description="Link to switch to the user's loyalty account region"
        values={{ currency: loyaltyCurrencyLabel }}
      />
    </TextLink>
  )

  if (variant === 'inline') {
    return switchLink
  }

  return (
    <Group direction="vertical" gap={2}>
      <Caption variant="medium" colour="normal-contrast">
        <FormattedMessage
          id="GBH0wDkFQFp96byoFWjN"
          defaultMessage="To use your points"
          description="Prompt shown in burn slider when user is browsing outside their loyalty account region"
        />
      </Caption>
      {switchLink}
    </Group>
  )
}

export default LoyaltySwitchRegionPrompt
